<template>
    <div>
        <div class="display-all" v-if="display_all">
            <div class="alert alert-warning pt-3">
                <h3 class="text-center"  v-html="$t('intern_qpay_cancel.abgebrochen_titel')"></h3>
                <div class="text-center" v-html="$t('intern_qpay_cancel.abgebrochen_text')"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'payment-cancel',
        data() {
            return {
                display_all: true,
            }
        },
        created() {
            this.$cookies.remove('currentBooking');
        },
        mounted() {
            window.parent.postMessage('SCROLL_TO_TOP');  
        },
    }
</script>

<style scoped>
.display-all{
    background-color: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
}
</style>